import { getCookie } from 'Lib/cookies/cookies';

const $body = $('body');
const cookieName = 'COOKIE_ACCEPT';

function setCookie(name) {
    const date = new Date(new Date().getTime() + 60 * 1000 * 60 * 24 * 365 * 10); // на 10 лет

    document.cookie = `EKSMO_${name}_SHOWED=Y; path=/; domain=${window.location.hostname}; expires=${date.toUTCString()}; SameSite=None; Secure`;
}

function appendHtml() {
    if (!$('html').hasClass('is-authorized')) {
        if (getCookie(`EKSMO_${cookieName}_SHOWED`) !== 'Y' && !$('.cookie-accept').length) {
            $(document).ready(() => {
                $body.append(`
                    <div class="cookie-accept bg bg_lighterblack">
                        <div class="container">
                            <div class="cookie-accept__row">
                                <div class="cookie-accept__left">
                                    <div class="cookie-accept__text">
                                         Мы используем cookies для&nbsp;улучшения работы сайта. Продолжая пользоваться сайтом, вы&nbsp;<a href="/soglasie/soglasie-na-ispolzovanie-i-obrabotku-cookie-faylov/" class="a a_orange a_noline">соглашаетесь с&nbsp;использованием cookies</a> и&nbsp;<a href="/publishers/politika-obrabotki-personalnykh-dannykh/" class="a a_orange a_noline">обработкой персональных данных</a>.
                                    </div>
                                </div>
                                <div class="cookie-accept__right">
                                    <div class="cookie-accept__btn btn btn_small btn_full-width btn_orange">Принять</div>
                                </div>
                            </div>
                        </div>
                    </div>
                `);
            });
        }
    }
}

appendHtml();

$body.on('bitrixDynamicComposite.eksmo', () => {
    appendHtml();
});

$body.on('click', '.cookie-accept__btn', () => {
    setCookie(cookieName);
    $('.cookie-accept').remove();
});